(() => {
  const syncPolicyCheckout = checkbox => {
    const wrapper = checkbox.closest('.gr-cart__ctas');
    const button = wrapper?.querySelector('[data-policy-checkout-button]');
    if (!button) return;
    if (checkbox.checked) {
      button.disabled = false;
      button.removeAttribute('disabled');
    } else {
      button.disabled = true;
      button.setAttribute('disabled', 'disabled');
    }
  };
  document.addEventListener('click', event => {
    const checkbox = event.target.closest('[data-policy-checkbox]');
    if (!checkbox) return;
    setTimeout(() => syncPolicyCheckout(checkbox), 0);
  });
  document.addEventListener('change', event => {
    const checkbox = event.target.closest('[data-policy-checkbox]');
    if (!checkbox) return;
    syncPolicyCheckout(checkbox);
  });
})();